import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AppConfig } from "../config/app.config";
import { BehaviorSubject, Observable } from "rxjs";
import { AuthService } from "../auth/auth.service";

@Injectable({
    providedIn: 'root'
})
export class PolicyDocumentService {
    private apiUrl = AppConfig.apiUrl;
    authservice = inject(AuthService)       
    private token = this.authservice.getToken()    
    httpClient = inject(HttpClient);
    downloadPolicyDcoument$ = new BehaviorSubject<boolean>(false);
    emailPolicyDocument$ = new BehaviorSubject<boolean>(false)
    downloadEndorsementDocument$ = new BehaviorSubject<boolean>(false);

    getDownloadPolicyDocument() {
        return this.downloadPolicyDcoument$.asObservable();
    }

    setDownloadPolicyDocument(data: boolean) {
        this.downloadPolicyDcoument$.next(data);
    }

    getEmailDocument() {
        return this.emailPolicyDocument$.asObservable();
    }

    setEmailDocument(data: boolean) {
        this.emailPolicyDocument$.next(data);
    }

    onDownloadPolicyDocument(policyId: number, branchId: number) {
        const path=`/api/PolicyReport/GetPolicyDocumentDetails?PolicyId=${policyId}&branchId=${branchId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    UpdateIsDownloadEmailComplete(policyId: number, userId: number,isDownloadEmailCompleteFlag:number) {
        const path=`/api/Policy/UpdateIsDownloadEmailComplete?policyId=${policyId}&userId=${userId}&isDownloadEmailCompleteFlag=${isDownloadEmailCompleteFlag}`;
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`,{});
    }

    getIsDownloadEmailComplete(policyId: number) {
        const path=`/api/Policy/${policyId}`;
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getDownloadEndorsementDocument() {
        return this.downloadEndorsementDocument$.asObservable();
    }

    setDownloadEndorsementDocument(data: boolean) {
        this.downloadEndorsementDocument$.next(data);
    }

    onDownloadEndorsementDocument(policyId: number){
        const path=`/api/PolicyReport/GetEndorsementDocument?policyId=${policyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    downloadPdf(formData : any): Observable<Blob>{
        const path=`/api/DocumentGen/PolicyGeneration`;
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy/GenerateDocument?path=${encodedPath}`, formData,{ responseType: 'blob' });
    }

    emailPdf(formData : any){
        const path=`/api/DocumentGen/MailDocGeneration`;
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, formData);
    }
  

}